import {
    prop,
    getServerTime,
    sec2txt,
    time2text,
    fixNumber,
    isArray,
    isNumber,
    isString
} from "../../common/utils";
import { getCity, subCityList} from "./address";
import { myPreAwards, myFinalAwards, hasRealityAward, needAddress, needBind } from "./award";

// function config(state){
//     const configInfo = state.configInfo
//     return configInfo && configInfo.realityCupId > 0 ? configInfo : null
// }

function configNum(key, defaultValue) {
    return (state) => {
        const n = prop(state.configInfo, key)
        return isNumber(n) || isString(n) ? +n : defaultValue
    }
}

function configInfo(key, defaultValue) {
    return (state) => {
        const v = prop(state.configInfo, key)
        return v === undefined ? defaultValue : v
    }
}

function detailNum(key, defaultValue) {
    return (state) => {
        const n = prop(state.myDetail, key)
        return isNumber(n) || isString(n) ? +n : defaultValue
    }
}

function getUrl(state) {
    return (key, defaultValue) => {
        const v = prop(state.Urls, key)
        return v === undefined ? defaultValue : v
    }
}

function detailInfo(key, defaultValue) {
    return (state) => {
        const v = prop(state.myDetail, key)
        return v === undefined ? defaultValue : v
    }
}

function myInfoOf(key, defaultValue) {
    return (state) => prop(state.myInfo, key, defaultValue)
}
const myUid = myInfoOf('uid', 0)
const myNick = myInfoOf('nick', '')
// const myMobile = myInfoOf('mobile', '')
const myLogo = myInfoOf('logoSrc', '')
const isLoggedUser = (state) => myUid(state) > 0 // 已登录用户（包括临时账号）

function _timeOf(key, state) {
    const n = prop(state.timeMap, key)
    return n > 0 ? +n : 0
}

function timeOf(key) {
    return (state) => _timeOf(key, state)
}

function nowTime(state) {
    // console.log([typeof state.nowTime, state.nowTime]);
    // return state.nowTime
    const _nowTime = state._nowTime
    const st = getServerTime()
    return _nowTime > st ? _nowTime : st
}

function before(key) {
    return (state) => nowTime(state) < _timeOf(key, state)
}

function after(key) {
    return (state) => {
        const time = _timeOf(key, state)
        return time > 0 && nowTime(state) > time
    }
}

function between(begin, end) {
    return (state) => {
        const nowTime = getServerTime()
        return nowTime >= _timeOf(begin, state) && nowTime < _timeOf(end, state)
    }
}

function leftSecs(state, endTime) {
    const time = nowTime(state)
    return endTime > time ? Math.ceil((endTime - time) / 1000) : 0
}

// function finishOf(key) {
//     return (state) => _timeOf(key, state)
// }

function _getBlock(name, state) {
    return prop(state.blockMap, name, null)
}

function getBlock(state) {
    return (name) => _getBlock(name, state)
}

function getBlockType(state) {
    return (name) => prop(_getBlock(name, state), 'type', 0)
}

function getBlockData(state) {
    return (name) => {
        const B = _getBlock(name, state)

        //  alert(JSON.stringify(state.blockMap))
        if (B) {
            const {
                type,
                data
            } = B
            if (type === 1 || type === 2) { // 单图、多图
                return data && data.length > 0 ? data : null
            }
            // console.log(data);
            return data
        }
        return null
    }
}

function _getDkGames(state, cupId) {
    const _myDkGames = state._myDkGames
    if (_myDkGames && isArray(_myDkGames[cupId])) {
        return _myDkGames[cupId]
    }
    return []
}

// 是否为已验证手机号用户
function isValidUser(state) {
    const {
        myInfo
    } = state
    if (myInfo && myInfo.uid > 0 && myInfo.isValidMobile > 0) {
        return true
    }
    return false
}



export default {
    //   config,
    pId: configNum('pId', 0),
    status: configNum('status', 0),
    cupType: configNum('cupType', 0),
    experienceCupType: configNum('experienceCupType', 0),
    realityCupId: configNum('realityCupId', 0),
    matchName: configInfo('name', '比赛活动'),
    advanceScore: configNum('advanceScore', 0), // 晋级分数线

    // block
    getBlock,
    getBlockType,
    getBlockData,

    getCity,
    subCityList,

    // dk
    dkCup(state) {
        return cupId => {
            const {
                _cupMap
            } = state
            return _cupMap ? _cupMap[cupId] : null
        }
    },
    dkCupPlayer(state) {
        return cupId => {
            const {
                _myDkCupPlayers
            } = state
            return _myDkCupPlayers ? _myDkCupPlayers[cupId] : null
        }
    },

    // time diff
    isBefore(state) {
        return (time) => time > 0 && nowTime(state) < time
    },
    isAfter(state) {
        return (time) => time > 0 && nowTime(state) > time
    },
    isBetween(state) {
        return (beginTime, endTime) => beginTime > 0 && endTime > 0 && beginTime <= nowTime(state) && nowTime(state) < endTime
    },

    // time
    nowTime,
    signBegin: timeOf('signBegin'),
    signEnd: timeOf('signEnd'),
    signRes: timeOf('signRes'),
    preBegin: timeOf('preBegin'),
    preEnd: timeOf('preEnd'),
    preRes: timeOf('preRes'),
    finalBegin: timeOf('finalBegin'),
    finalEnd: timeOf('finalEnd'),
    finalRes: timeOf('finalRes'),
    awardTime: timeOf('awardTime'), // 颁奖时间
    addressEnd: timeOf('addressEnd'),

    // beforeXxx: 在 Xxx 之前
    beforeSign: before('signBegin'),
    beforePre: before('preBegin'),
    beforeFinal: before('finalBegin'),

    // afterXxx: 在 Xxx 之后
    endSign: after('signEnd'), // 签名结束
    endPre: after('preEnd'), // 预赛结束
    endFinal: after('finalEnd'), // 决赛结束

    // afterXxx: 在 Xxx 之后
    afterSign: after('signEnd'), // 签名结束
    afterPre: after('preRes'), // 预赛成绩公布
    afterFinal: after('finalRes'), // 决赛成绩公布

    // inXxx: 在 Xxx 期间
    inSignStage: between('signBegin', 'signEnd'), // 报名中
    waitPreBegin: between('signEnd', 'preBegin'), // 报名结束，等待预赛开始
    inPreStage: between('preBegin', 'preEnd'), // 预赛中
    waitPreRes: between('preEnd', 'preRes'), // 预赛结束，等待公布结果
    waitFinalBegin: between('preRes', 'finalBegin'), // 预赛结果公布，等待决赛开始
    inFinalStage: between('finalBegin', 'finalEnd'), // 决赛中
    waitFinalRes: between('finalEnd', 'finalRes'), // 决赛结束 ~ 结果公布

    // myInfo
    myUid,
    myNick,
    myLogo,
    isLoggedUser,
    isValidUser,

    myPreAwards,
    myFinalAwards,

    hasRealityAward,
    needAddress,
    needBind,

    // myDetail
    isSign: detailNum('isSign', 0), // 是否已报名
    isFinishPre: detailNum('isFinishPre', 0), // 是否已完成初赛
    isAdvance: detailNum('isAdvance', 0), // 是否已晋级
    allCupNum: detailNum('allCupNum', 0), // 初赛：总擂台数
    finishCupNum: detailNum('finishCupNum', 0), // 初赛：已完成擂台数

    maxAvgScore: detailNum('maxAvgScore', 0), // 最高平均分（预赛擂台）
    preScore: detailNum('preScore', 0), // 预赛得分
    preRank: detailNum('preRank', 0), // 预赛排名

    finalRank: detailNum('finalRank', 0), // 决赛排名
    finalScore: detailNum('finalScore', 0), // 决赛赛得分
    isFinishFinal: detailNum('isFinishFinal', 0), // 是否完成决赛
    finalFinishTime: detailInfo('finalFinishTime', ''), // 决赛完成时间

    getDkGames(state) {
        return (cupId) => _getDkGames(state, cupId)
    },

    getUrl,

    // utils
    // 剩余秒数
    leftSecs(state) {
        return (endTime) => leftSecs(state, endTime)
    },
    // 剩余时间
    leftFor(state) {
        return (endTime) => sec2txt(leftSecs(state, endTime), "zh-cn")
    },
    time2text() {
        return (time, format) => time2text(time, format)
    },
    fixNumber() {
        return (n, length) => fixNumber(n, length)
    }
}
